<template>
  <div class="rx-sheet" role="dialog" aria-modal="true" :aria-label="title" @keydown.esc="close">
    <div class="rx-sheet__backdrop" @click="close"></div>
    <div class="rx-sheet__panel">
      <div class="rx-sheet__handle" aria-hidden="true"></div>
      <div v-if="title" class="rx-sheet__title" :title="title">{{ title }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
// Simple M3-style modal bottom sheet. Tap outside / Esc emits `close` (unless `locked`).
export default {
  name: 'BottomSheet',
  props: {
    title: { type: String, default: '' },
    locked: { type: Boolean, default: false }
  },
  mounted () {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  },
  methods: {
    close () {
      if (!this.locked) this.$emit('close')
    }
  }
}
</script>

<style scoped>
.rx-sheet {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1070;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.rx-sheet__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}
.rx-sheet__panel {
  position: relative;
  background: #fff;
  border-radius: 16px 16px 0 0;
  max-height: 85vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: env(safe-area-inset-bottom);
  color: #1f2937;
}
.rx-sheet__handle {
  width: 32px;
  height: 4px;
  border-radius: 2px;
  background: #d1d5db;
  margin: 10px auto 4px;
}
.rx-sheet__title {
  padding: 8px 20px 10px;
  font-size: 17px;
  font-weight: 700;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: 1px solid #eef0f2;
}
</style>
